(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-info"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    var forms = document.querySelectorAll('form[id^="product-form-"]');

    forms.forEach(function(form) {
      form.addEventListener('variant:change', function(event) {
        var variant = event.detail.variant;
        var titleEl = form.closest('safe-sticky')?.querySelector('[data-product-title]');
        if (!titleEl) return;

        var originalTitle = titleEl.getAttribute('data-original-title');
        var isGFlex = variant && variant.options && variant.options.some(function(opt) {
          return opt.toLowerCase().indexOf('g-flex') !== -1;
        });

        var linkEl = titleEl.querySelector('a');
        var finalTitle = isGFlex ? originalTitle + ' - Grom' : originalTitle;
        if (linkEl) {
          linkEl.textContent = finalTitle
        } else {
          titleEl.textContent = finalTitle
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
